import { ToastContainer } from 'react-toastify';

import { Footer } from '@/app/components/Footer/Footer';
import { Header } from '@/app/components/Header/Header';
import { ScrollToTop } from '@/app/components/ScrollToTop/ScrollToTop';
import { ServicePage } from '@/app/pages/ServicePage/ServicePage';
import { AppRouter } from '@/app/providers/router/AppRouter';
import { appRoutes } from '@/app/providers/router/config';
import { isServiceMode } from '@/app/shared/constants/env';
import { useSentryUser } from '@/app/shared/hooks/useSentryUser';

function App() {
  useSentryUser();
  return (
    <div className='flex min-h-screen flex-col'>
      <ScrollToTop />
      <ToastContainer />
      <Header />
      <main className='relative flex-1'>
        <div
          aria-hidden
          className='pointer-events-none absolute top-0 left-1/2 z-0 h-280 w-full max-w-311 -translate-x-1/2 -translate-y-1/2'
          style={{ background: 'var(--app-halo-gradient)' }}
        />
        <div className='relative z-10'>
          {isServiceMode ? <ServicePage /> : <AppRouter routes={appRoutes} />}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
